<template>
  <div id="change-evn" class="change-evn">
    <div class="container-box">
      <h3 class="text-3xl">Einstellungen</h3>
      <form>
        <div class="inputs-container content-limiter">
          <div class="radio-group radio-flex">
            <label class="text-sm font-medium">
              <input type="radio" name="evn" value="ALL" v-model="currentEvnConfiguration.evn">
              <span class="custom-radio"></span> Einzelverbindungsnachweise mit vollständiger Zielrufnummer
            </label>
            <label class="text-sm font-medium">
              <input type="radio" name="evn" value="ANO" v-model="currentEvnConfiguration.evn">
              <span class="custom-radio"></span> Einzelverbindungsnachweise mit gekürzter Zielrufnummer
            </label>
            <label class="text-sm font-medium">
              <input type="radio" name="evn" value="NOT" v-model="currentEvnConfiguration.evn">
              <span class="custom-radio"></span> Kein Einzelverbindungsnachweis
            </label>
          </div>
          <button class="button button--primary --fit-content --align-end" @click="saveSettings()" :disabled="loading">Speichern</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'
import { mapActions } from 'vuex'

export default {
  name: 'ChangeEvn',

  data () {
    return {
      loading: false,
      currentEvnConfiguration: {
        evn: ''
      }
    }
  },
  methods: {
    ...mapActions('evn', [
      'saveEvnSettings'
    ]),
    saveSettings: async function () {
      this.loading = true
      await this.saveEvnSettings({ selectedEvn: this.currentEvnConfiguration.evn })
      this.loading = false
    }
  },
  computed: {
  },
  mixins: [
    transaction('changeEvnSettings'),
    slotProxy()
  ],
  apollo: {
    currentEvnConfiguration: function () {
      return wrapQuery(
        gql`query changeEvnSettings {
          currentEvnConfiguration {
              evn
          }
        }`, this,
        'currentEvnConfiguration'
      )
    }
  }
}
</script>
